export default __webpack_public_path__ + "static/media/deep-sea.0f156d82.svg";